/**
 * Imperative bridge so UI actions (open thread, start outbound call, open
 * notification detail) can await a soft-lock unlock without importing the
 * React hook. `useAppLock` registers the live unlock function on mount.
 *
 * Also re-exports a sync locked check via the store for call sites that only
 * need to know whether to prompt.
 */

import { isAppLocked } from '../../stores/app-lock-store'

type UnlockFn = () => Promise<boolean>

let unlockFn: UnlockFn | null = null

export function registerSoftLockUnlock(fn: UnlockFn | null): void {
  unlockFn = fn
}

/**
 * If the app is not soft-locked, resolves true immediately. Otherwise prompts
 * biometric / passcode unlock and resolves with the result.
 */
export async function ensureSoftUnlocked(): Promise<boolean> {
  if (!isAppLocked()) return true
  if (!unlockFn) return false
  return unlockFn()
}
